module.exports = __webpack_public_path__ + "static/media/logo-previred.dd212cdb.svg";